module.exports = __webpack_public_path__ + "images/pages/for_business/sp/sec13_10cbc6aea1fa867b1931c25d062c0e70.jpg";